import fetch from 'isomorphic-fetch';
import { getEngineKey, getEngineUrl } from '../helpers/sysAttrs';

/**
 * Action types for profiles fetching
 */
export const PROFILES_FETCH_REQUEST = 'PROFILES_FETCH_REQUEST';
export const PROFILES_FETCH_SUCCESS = 'PROFILES_FETCH_SUCCESS';
export const PROFILES_FETCH_FAILURE = 'PROFILES_FETCH_FAILURE';

/**
 * Action types for profiles types fetching
 */
export const PROFILES_TYPES_FETCH_REQUEST = 'PROFILES_TYPES_FETCH_REQUEST';
export const PROFILES_TYPES_FETCH_SUCCESS = 'PROFILES_TYPES_FETCH_SUCCESS';
export const PROFILES_TYPES_FETCH_FAILURE = 'PROFILES_TYPES_FETCH_FAILURE';

/**
 * Action type for selected profiles type change
 */
export const PROFILES_TYPE_CHANGE = 'PROFILES_TYPE_CHANGE';

/**
 * Action type for user search change
 */
export const PROFILES_SEARCH_CHANGE = 'PROFILES_SEARCH_CHANGE';

/**
 * Action type for profiles page change
 */
export const PROFILES_PAGE_CHANGE = 'PROFILES_PAGE_CHANGE';

/**
 * Function to make a search request to server
 */
export function callApi(requestType, successType, failureType) {
    return (dispatch, getState) => {
        dispatch({ type: requestType });

        const { search, profiles } = getState().profiles;
        return fetch(`${getEngineUrl()}/search.json`, {
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json' }),
            body: JSON.stringify({
                engine_key: getEngineKey(),
                page: search.profilesType ? profiles.page : undefined,
                q: search.query,
                per_page: 15,
                sort_direction: {},
                filters: {
                    page: {
                        type: ['profiles', 'course'],
                        profiles_type: search.profilesType || undefined,
                    },
                },
                facets: {
                    page: ['profiles_type'],
                },
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch profiles');
                }
                return response.json();
            })
            .then(payload => dispatch({
                type: successType,
                payload,
            }))
            .catch((error) => {
                dispatch({
                    type: failureType,
                    error,
                });
                return Promise.reject(error);
            });
    };
}

/**
 * Function to search profiles on server
 */
export function fetchProfiles() {
    return callApi(
        PROFILES_FETCH_REQUEST,
        PROFILES_FETCH_SUCCESS,
        PROFILES_FETCH_FAILURE,
    );
}

/**
 * Function to search profiles types on server
 */
export function fetchProfilesTypes() {
    return callApi(
        PROFILES_TYPES_FETCH_REQUEST,
        PROFILES_TYPES_FETCH_SUCCESS,
        PROFILES_TYPES_FETCH_FAILURE,
    );
}

/**
 * Function to change profiles type
 */
export function changeProfilesType(profilesType) {
    return {
        type: PROFILES_TYPE_CHANGE,
        profilesType,
    };
}

/**
 * Function to change search
 */
export function changeSearch(search) {
    return {
        type: PROFILES_SEARCH_CHANGE,
        search,
    };
}

/**
 * Function to change page
 */
export function changePage(page) {
    return {
        type: PROFILES_PAGE_CHANGE,
        page,
    };
}



// WEBPACK FOOTER //
// ./src/js/Profiles/profiles.actions.js